import { IPv8Service } from './IPv8Service';
import { AttributeWithHash } from './types/Attribute';
import { Dict } from './types/Dict';
import { IVerifierService, VerifyOptions } from './types/IVerifierService';

const log = console.log

export class VerifierService implements IVerifierService {
    private verified: Dict<VerificationRecord[]> = {}

    constructor(private ipv8service: IPv8Service, private timeInMillis: () => number = Date.now) { }

    public stop() {
        return this;
    }

    public verify(
        mid_b64: string,
        credentials: AttributeWithHash[],
        options?: VerifyOptions
    ): Promise<boolean> {
        return Promise.all(credentials.map(c => this.verifySingle(mid_b64, c, options))).then(
            oks => !oks.some(ok => !ok)
        )
    }

    protected verifySingle(
        mid_b64: string,
        credential: AttributeWithHash,
        options?: VerifyOptions
    ): Promise<boolean> {
        const record: VerificationRecord = { credential, requestedAtTimeInMillis: this.timeInMillis() }
        this.put(mid_b64, record)

        return this.ipv8service
            .awaitVerification(mid_b64, credential.attribute_hash, credential.attribute_value)
            .then(ok => {
                log('Verification of', credential.attribute_name, 'of peer', mid_b64, 'resulted in', ok)

                if (ok) {
                    record.verifiedAtTimeInMillis = this.timeInMillis()
                }
                return ok
            })
    }

    protected isVerified(
        mid_b64: string,
        credential: AttributeWithHash,
        maxAgeInSeconds: number
    ): boolean {
        const record = this.get(mid_b64).find(
            rec => rec.credential.attribute_hash === credential.attribute_hash
        )
        const minTime = this.timeInMillis() - maxAgeInSeconds * 1000
        return record && record.verifiedAtTimeInMillis && record.verifiedAtTimeInMillis > minTime
    }

    protected get(mid_b64: string) {
        return this.verified[mid_b64] || []
    }

    protected put(mid_b64: string, record: VerificationRecord) {
        if (!this.verified[mid_b64]) {
            this.verified[mid_b64] = []
        }
        this.verified[mid_b64].push(record)
    }
}

interface VerificationRecord {
    credential: AttributeWithHash
    requestedAtTimeInMillis: number
    verifiedAtTimeInMillis?: number
}
